<template>
  <ModalSide :class="['collect-product-page']" ref="modal" @close="handleClose" :layer="3">
    <Loading class="static" v-if="is_loading" />

    <div :class="['product-data-wrap', is_creator && 'collect-data-wrap-samll']" v-else :show_bar="true">
      <div class="close-header" :key="refrashHeader">
        <div class="icon-box">
          <svg-icon name="close" @click.native="$refs.modal.close();" />
        </div>
        <figure class="avatar">
          <img :src="item.userProfile.avatar_full_url" @error="imageError($event)" />
        </figure>
        <tippy class="creat-name">{{ item.user_name }}</tippy>

        <el-button v-if="item.contentModertaion && item.contentModertaion.flag_status && collectionPermission === 100 && ((item.contentModertaion.flag_status && item.can_not_edit) || !item.can_not_edit)"
          @click="openCollectionPopup(4)">Resolve this
          flag</el-button>
        <div class="hr" v-if="item.contentModertaion && item.contentModertaion.flag_status && collectionPermission === 100 && ((item.contentModertaion.flag_status && item.can_not_edit) || !item.can_not_edit)"></div>
        <el-button  v-if="!item.can_not_edit && collectionPermission === 100 && !item.curation_id" 
          :class="[item.disabledCheckbox && 'disabled-box-btn']"
          @click="openCollectionPopup(1)">
          <Checkbox :checked="item.disabledCheckbox" :label_text="'Disable'" />
        </el-button>
        <div class="hr" v-if="!item.can_not_edit && !item.curation_id "></div>
        <el-button @click="viewLive();" v-if="!item.disabledCheckbox && !item.can_not_edit">
          <svg-icon name="go-out" />
          <span>View live</span>
        </el-button>

        <div class="icon-box2" v-if="!item.disabledCheckbox && !item.can_not_edit" @click="copyLink()">
          <svg-icon name="link" />
        </div>
        <div :class="['icon-box2', (item.can_not_edit || collectionPermission !== 100 ) && 'disabled-icon']"
          @click="openCollectionPopup(3)" v-if="item.contentModertaion &&  ((item.contentModertaion.flag_status && item.can_not_edit) || !item.can_not_edit ) && !item.curation_id">
          <svg-icon :name="item.contentModertaion.flag_status ? 'flag-color' : 'flag-2'"
            :class="[`svg-flag-${item.flag.color}`]" />
        </div>
        <div class="icon-box2" @click="openHistory()">
          <svg-icon name="scheduled" />
        </div>
        <div class="hr"></div>
        <div class="spec-btn-box">
          <el-button class="spec-btn1" :disabled="isPrevDisabled" @click="goPrev">
            <svg-icon name="arrow-next" />
          </el-button>
          <el-button class="spec-btn2" :disabled="isNextDisabled" @click="goNext">
            <svg-icon name="arrow-next" />
          </el-button>
        </div>
      </div>

      <div :class="['all-content', !openHistoryVal && 'only-block']">
        <div class="detail-content">
          <header>
            <collection-images :image="item.cover_image_url" :images="item.first_4_product_thumbnails" />

            <div class="middle">
              <div style="display: flex;align-items: center; gap: 8px;">
                <tippy class="name" :delay="[0, 20]" placement="right" :content="item.name">
                  {{ item.name }}
                </tippy>
                <span class="curated-label" v-if="item.curation_id">Curated</span>
              </div>
              <tippy class="desc" :delay="[0, 20]" placement="right" :content="desc_text">{{ desc_text }}</tippy>
              <div class="line">
                <span class="row row-date">
                  <div class="row-name">Created date:</div>{{ item.created_at }}
                </span>
                <span class="row row-date">
                  <div class="row-name">Last update:</div>{{ item.updated_at }}
                </span>
                <span class="row row-date" :key="content_moderation_status">
                  <div class="row-name">Visibility:</div>
                  <p v-if="item.is_active && item.is_publish !== 0">In storefront</p>
                  <p v-else >Unlisted</p>

                </span>
                <span class="row" v-if="item.status">
                  <div class="row-name">Status:</div>
                  <tippy :delay="[0, 20]" class="storefront-state class-red" v-if="item.curation_id && item.is_publish === 0">
                    Inactive
                  </tippy>
                  <tippy v-else :delay="[0, 20]" class="storefront-state" :class="['class-' + item.status.color]">
                    {{ item.status.name }}
                  </tippy>
                </span>

              </div>
              <div class="hint" v-if="is_show_hint">
                <SvgIcon name="alert" class="disabled-alert" />
                This {{ typeTitle }} isn't available in the storefront anymore. It no longer generate any sales or
                analytics.
              </div>
              <div class="hint" v-else-if="item.is_deleted">
                <SvgIcon name="alert" class="disabled-alert" />
                This {{ typeTitle }} was deleted by the creator and cannot generate any new performance metrics
                including
                sales.
              </div>
              <div class="hint hint-blue" v-else-if="item.is_disabled">
                <SvgIcon name="alert" class="disabled-alert" />
                This {{ typeTitle }} is not currently active and cannot generate any performance metrics.
              </div>
            </div>

          </header>


          <div class="collect-product-page-title">
            <h3>Summary&nbsp;({{ data.length > 0 ? item.product_count : 0 }})</h3>
            <div class="right">
              <Dropdown v-if="can_show_include"
                :items="data_source_items"
                :direction_type="'left'"
                :icon_direction_type="'right'"
                :default_value="0"
                @update-dropdown="onDataSourceChange"
              />

              <DatePicker v-show="!is_loading" @update-date="updateDate" :date_range="date_range" ref="date_picker" />
              <Dropdown v-if="!is_loading" :items="brandList" :is_update_index="true" :is_select_dropdown="true"
                :multi_pick="'Brand'" :default_value="0" @update-dropdown="updateBrand" :key="filterKey" />
              <Dropdown v-if="!is_loading" :items="sort_select" :direction_type="'right'" :icon="'filter'"
                :default_value="sort_index" @update-dropdown="updateSort" :key="drop_key" />
              <Pagenavi :disabled="data.length === 0" :page_current="sort.page" :page_total="sort.total_page"
                @goto-page="gotoPage" />
            </div>
          </div>

          <CollectionFilterResults :params="params" :theType="type" @update-filter="updateFilter" v-if="params.brands.length > 0"/>

          <Scrollbar :show_bar="true" ref="tableScrollBox">

            <NoData v-if="data.length === 0 && !isFilter" :image="require('@/assets/images/data.png')" :title="''"
              :text="'This creator has not added any products to their Collection yet.'" />

            <Table v-else>
              <template #head>
                <tr>
                  <th class="title"><span>Product</span></th>
                  <th>
                    <CollectionTh :name="'created_at'" :title="'Added Date'" :sort_value="sort" @sort="sortFun"
                      :content="'Added Date'" />
                  </th>
                  <th>
                    <CollectionTh :name="'views'" :title="'Product Views'" :sort_value="sort" @sort="sortFun"
                      :content="'Cumulative product views in the collection for the time period selected.'" />
                  </th>
                  <th>
                    <CollectionTh :name="'clicks'" :title="'Clicks'" :sort_value="sort" @sort="sortFun"
                      :content="'Cumulative link clicks on products in the Collection during the time period selected.'" />
                  </th>
                  <th>
                    <CollectionTh :name="'sales'" :title="'Sales'" :sort_value="sort" @sort="sortFun"
                      :content="'Total number of sales driven by the Collection during the time period selected.'" />
                  </th>
                  <th class="w-100-p">
                    <CollectionTh :name="'sales_value'" :title="'Sales Value'" :sort_value="sort" @sort="sortFun"
                      :content="'Gross transaction value driven by the Collection during the time period selected.'" />
                  </th>

                </tr>
              </template>

              <template #body>
                <template v-if="data.length === 0 && isFilter">
                  <tr>
                    <td colspan="13">
                      <NoData />
                    </td>
                  </tr>
                </template>

                <tr v-else v-for="(row, index) in data" :key="index" :class="{ selected: row.is_selected }">
                  <td class="title">
                    <div class="title-content">
                      <img :src="row.client_img" @error="imageError($event)">
                      <div class="right">
                        <tippy class="name" :delay="[0, 20]" placement="right" :content="showFullText(row, 'name')"
                          @mouseover="isEllipsisActive($event, row)"><span>{{ handleName(row.products &&
                            row.products.name
                            ? row.products.name : null) }}</span>
                            <a class="product-link" target="_blank" :href="row.products.product_url" @click.stop>
                              <svg-icon name="share" />
                            </a>
                        </tippy>
                        <tippy class="small" :delay="[0, 20]" placement="right" :content="showFullText(row, 'brand')"
                          @mouseover="isEllipsisActive($event, row)"><span>{{ handleName(row.products &&
                            row.products.merchant_name
                            ? row.products.merchant_name : null) }}</span>
                          <span class="curated-label" v-if="row.curation_id">Curated</span>
                          <span class="curated-label remove-label" v-if="row.removed_by === 5 && row.deleted_at !== '---'">Remove</span>
                        </tippy>

                        <div class="price-line">
                          <div class="price">{{ row.products?.lowest_price }}</div>
                          <div class="alert" v-if="!row.is_display">Sold out</div>
                        </div>
                      </div>
                    </div>
                  </td>

                  <td>
                    <!-- {{ row.curation_id }} - {{ row.curation_type }} - {{ row.created_by }} <br /> -->
                    <template v-if="item.curation_id && !row.curation_id">
                      <span class="added-by-label">Added by creator</span><br />
                    </template>
                    <span>{{ row.created_at }}</span><br />
                    <span class="del" v-if="row.deleted_at !== '---'">Removed: {{ row.deleted_at }}</span>
                  </td>

                  <td><span>{{ row.views }}</span></td>
                  <td><span>{{ row.clicks }}</span></td>
                  <td><span>{{ row.sales }}</span></td>
                  <td class="w-100-p">
                    <span>${{ row.sales_value }}</span><br />
                    <span class="small" v-if="row.cid">{{ row.products && row.products.currency ? row.products.currency
                      :
                      "USD" }}</span>
                  </td>
                </tr>

                <td colspan="13" v-if="is_loading">
                  <Loading class="static" />
                </td>
              </template>

              <template #foot>
                <tr v-if="data.length > 0">
                  <td :colspan="2"> Total products: {{ total ? total.total_product_count : 0 }} </td>

                  <td>{{ handleNum(total ? total.total_views : 0) }}</td>
                  <td>{{ handleNum(total ? total.total_clicks : 0) }}</td>
                  <td>{{ handleNum(total ? total.total_sales : 0) }}</td>
                  <td>${{ total ? Number(total.total_sale_value).toFixed(2) : '0.00' }}</td>
                </tr>
              </template>
            </Table>
          </Scrollbar>
        </div>

        <CollectionProductHistory :openHistoryVal="openHistoryVal" @handleOpenHistort="openHistory()" :type="type" :user_name="item.user_name" :user="item"
          :contentId="item.id" :key="refrashHeader" @handleCloseModel="$refs.modal.close();" @handleOpenHistortValue="getContnetStatus"/>
      </div>
    </div>
  </ModalSide>
</template>

<script setup>
import { ref, computed, onMounted, getCurrentInstance } from 'vue';
import moment from 'moment';

import ModalSide from '@/components/ui/ModalSide.vue';
import Content from '@/components/ui/Content.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Table from '@/components/ui/Table.vue';
import SvgIcon from '@/components/ui/SvgIcon.vue';
import Loading from '@/components/ui/Loading.vue';
import NoData from '@/components/creator/NoData.vue';
import DatePicker from '@/components/ui/DatePicker.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import CollectionTh from '@/components/creator/CollectionProductTh.vue';
import CollectionFilterResults from '@/components/creator/CollectionTemplate/CollectionFilterResults.vue';
import { useCollectionFilter } from '@/components/creator/collectionFilterFunction.js';
import { Sort_select_coll_pod_list, SwitchSort, ImageError, HandleNum, HandleName, PickSortIndex } from '@/utils/SwitchFun';
import formatMoney from '@/utils/formatMoney';
import Checkbox from '@/components/ui/Checkbox.vue';
import { ElButton } from 'element-plus';
import Pagenavi from '@/components/ui/Pagenavi.vue';
import copyToClipboard from 'copy-to-clipboard';
import { useNotification } from '@/components/ui/notification';
import CollectionProductHistory from '@/components/creator/CollectionTemplate/CollectionProductHistory.vue';
import { useStore } from 'vuex';
import CollectionImages from '../ui/CollectionImages.vue';
import handleProductData from '@/utils/HandleProductData';


const store = useStore();
const { callApiTypeId } = useCollectionFilter();
const { openNotBottom } = useNotification();
const app = getCurrentInstance();
const $filters = app.appContext.config.globalProperties.$filters;
const $ajax = app.appContext.config.globalProperties.$ajax;
const eventBus = app.appContext.config.globalProperties.EventBus;
const modalOpenVal = ref(false);
const item = ref({});
const data_info = ref(null);
const is_loading = ref(true);
const sort_select = Sort_select_coll_pod_list;
const sort_index = ref(0);
const drop_key = ref(0);
const date_range = ref({
  start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
  end_date: moment().add(-1, 'days').format('YYYY-MM-DD')
});
const params = ref({
  status: 0,
  type: 0,
  flag: 0,
  anchor_status: 0,
  brands: [],
  keyword: '',
});
const filterKey = ref(0);

const sort = ref({
  sort_key: 'views',
  sort_val: 'desc',
  page: 1,
  per_page: 50,
  total_page: 1
});

const data = ref([]);
const total = ref({});
const isFilter = ref(false);
const is_show_hint = ref(false);
const is_creator = ref(false);
const can_show_include = ref(false);
const shortlink_data = ref('all');
const data_source_items = [
  { text: 'All Data', value: 'all' },
  { text: 'Storefront Data', value: 'storefront' },
  { text: 'Links Data', value: 'shortlink' },
];
const openHistoryVal = ref(true);
const refrashHeader = ref(0);
const modal = ref(null);
const content_moderation_status = ref(null);

const desc_text = computed(() => {
  return item.value.description || `The creator did not include a description for this ${type.value}.`;
});

const type = ref('post');

const typeTitle = computed(() => {
  if (type.value === 'collection') {
    return 'Collection';
  } else if (type.value === 'post') {
    return 'Post';
  }
});

const brandList = ref([
  { id: 99999999, text: 'Brand: All', is_selected: true },
  { id: 2, text: 'Brand: 321' },
  { id: 3, text: 'Brand: 123' },
]);

const isPrevDisabled = ref(false);
const isNextDisabled = ref(false);
const collectionPermission = computed(() => {
  //50 can view /0 can not view/100 all can view can edit
  return store.state.user_data.permission_list?.contentModeration?.contentModeration?.permission;
});
//only collectionPermission now
// const disabledPermission = computed(() => {
//   return store.state.user_data.permission_list?.contentModeration?.canDisableContent?.permission;
// });

// const flagPermission = computed(() => {
//   return store.state.user_data.permission_list?.contentModeration?.canFlagContent?.permission;
// });
//++++++++++++++++++++++++++++++++++++++++++++
const imageError = ImageError;
const handleNum = HandleNum;
const handleName = HandleName;

const getContnetStatus = (val) => {
  content_moderation_status.value = val; 
};

const cleanMoal = () => {

  data.value = [];
  is_loading.value = true;
  sort.value.page = 1;
  sort.value.sort_key = 'views';
  sort.value.sort_val = 'desc';
  sort_index.value = 0;
  params.value.brands = [];
  can_show_include.value = false;
  shortlink_data.value = 'all';
};

const openModal = () => {
  eventBus.off('open-collect-product-modal');
  eventBus.on('open-collect-product-modal', (obj) => {
    cleanMoal();
    item.value = obj.data;
    item.value.product_count = item.value.product_count || 0;
    item.value.userProfile.avatar_full_url = item.value.userProfile?.avatar_full_url || require('@/assets/images/no-image.png');
    data_info.value = obj.data_info;
    date_range.value = obj.date_range;
    is_show_hint.value = obj.is_show_hint;
    //9671-new
    is_creator.value = obj.is_creator || false;
    type.value = obj.data.type || 'post';
    item.value.disabledCheckbox = obj.data.is_disabled || obj.data.is_hidden || obj.data.is_archvied;
    isPrevDisabled.value = !obj.hasPrev;
    isNextDisabled.value = !obj.hasNext;
    fetchData(true);
    modal.value.open();
    modalOpenVal.value = true;
    // console.log('openModal->item', item)
  });
};

const handleClose = () => {

  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('content_id')) {
    const url = new URL(window.location);
    url.searchParams.delete('content_id');
    window.history.replaceState(null, '', url.toString());
  }

  window.localStorage.removeItem('handleRowDataFromCollection');
  modalOpenVal.value = false;
  eventBus.emit('get-product-close');
};

const refrashModal = () => {
  eventBus.off('refrash-collection-product');
  eventBus.on('refrash-collection-product', (obj) => {
    item.value = obj;
    item.value.disabledCheckbox = obj.is_disabled || obj.is_hidden || obj.is_archvied;
    console.log('item.value(refrash-collection-product)', item.value)

    if (obj.needRefrashTable) {
      cleanMoal();
      fetchData();
      isPrevDisabled.value = !obj.hasPrev;
      isNextDisabled.value = !obj.hasNext;
    };

    refrashHeader.value++;
  });
};

const updateSort = (id) => {
  const getVal = SwitchSort(id.id);
  sort.value.sort_key = getVal.key;
  sort.value.sort_val = getVal.val;
  sort.value.page = 1;
  sort_index.value = PickSortIndex(sort_select, sort.value.sort_key, sort.value.sort_val);
  drop_key.value++;
  fetchData();
};

const updateBrand = (obj) => {
  const isAll = obj.id === 99999999;
  params.value.brands = [];
  brandList.value.forEach((item) => {
    if (isAll) {
      if (item.id === 99999999) {
        item.is_selected = true;
      } else {
        item.is_selected = false;
      }
    } else {
      if (item.id === obj.id) {
        item.is_selected = true;
      } else if (item.id === 99999999 && item.is_selected) {
        item.is_selected = false;
      }
    }

    if (item.is_selected && item.id !== 99999999) {
      params.value.brands.push({ id: item.id, text: item.text });
    }
  });
  sort.value.page = 1;
  fetchData();
};

const updateFilter = (obj) => {
  params.value = obj;
  //-------------------------
  const selectedIds = params.value.brands.map(b => b.id);

  brandList.value.forEach((brand, index) => {
    if (index === 0) {
      // 先預設為 false，之後再判斷是否需要設為 true
      brand.is_selected = false;
    } else {
      // 只要 ID 在選取清單中，就設為 true
      brand.is_selected = selectedIds.includes(brand.id);
    }
  });

  // 檢查其他項目是否都沒被選到（除了第 0 個）
  const othersAreAllFalse = brandList.value.slice(1).every(b => !b.is_selected);

  // 如果其他都沒選到，且第 0 個有在 selectedIds 中，才設為 true
  if (othersAreAllFalse) {
    brandList.value[0].is_selected = true;
  }
  console.log('brandList.value',brandList.value)
  //-------------------------
  filterKey.value += 1;
  sort.value.page = 1;
  fetchData();
}

const fetchData = (is_first) => {
  is_loading.value = true;
  const req_par = {
    anchor_collection_id: item.value.id,
    start_date: date_range.value.start_date,
    end_date: date_range.value.end_date,
    collection_type: item.value.type
  };

  const params_data = {
    ...req_par,
    ...sort.value
  };

  params_data['brand_ids[]'] = params.value.brands.map(e => e.id);

  const api_list = [
    $ajax('/creator/get-product-list-under-collection', {
      params: params_data,
      method: 'get'
    })
  ];


  api_list.push($ajax('/creator/get-product-list-under-collection-statistic', {
    params: req_par,
    method: 'get'
  }));

  if (is_first) {
    api_list.push($ajax('/analytics/brand-list', {
      params: {
        start_date: date_range.value.start_date,
        end_date: date_range.value.end_date,
        content_type: callApiTypeId(type.value),
        content_id: item.value.id
      },
      method: 'get'
    }));
  }


  Promise.all(api_list).then(([res1, res2, res3]) => {
    res1.data.data.data.forEach((item) => {
      item.client_img = item.products?.images?.img_200x200 || require('@/assets/images/no-image.png');
      item.created_at = $filters.momentFormat(item.created_at, 'll');
      item.deleted_at = $filters.momentFormat(item.deleted_at, 'll');
      item.views = handleNum(item.views);
      item.clicks = handleNum(item.clicks);
      item.sales = handleNum(item.sales);
      item.sales_value = item.sales_value ? Number(item.sales_value).toFixed(2) : '0.00';
    });


    // data.value = res1.data.data.data;
    res1.data.data.data.forEach((item) => {
      item.products = handleProductData(item.products);
      data.value.push(item);
    });
    sort.value.total_page = res1.data.data.last_page;

    if (res2) {
      total.value = res2.data.data[0] || null;
    }

    if (res3?.data.data && res3.data.data.length > 0) {
      brandList.value = res3.data.data.map((item) => ({
        id: item.id,
        text: `Brand: ${item.name}`,
        is_selected: false
      }));
      brandList.value.unshift({ id: 99999999, text: 'Brand: All', is_selected: true });
    }

    is_loading.value = false;
  }).catch((error) => {
    console.error('Error:', error);
    is_loading.value = false;
  });
};

const sortFun = (key) => {
  if (key === sort.value.sort_key) {
    sort.value.sort_val = sort.value.sort_val === 'asc' ? 'desc' : 'asc';
  } else {
    sort.value.sort_key = key;
    sort.value.sort_val = 'asc';
  }
  sort.value.page = 1;
  sort_index.value = PickSortIndex(sort_select, sort.value.sort_key, sort.value.sort_val);
  drop_key.value++;
  fetchData();
};

const showFullText = (row, type) => {
  if (row.is_ellipsis_active) {
    if (type === 'name') return row.products.name;
    if (type === 'brand') return row.products.merchant_name;
  }
  return '';
};

const isEllipsisActive = (e, row) => {
  row.is_ellipsis_active = e.target.offsetWidth < e.target.scrollWidth;
};

const updateDate = (obj) => {
  date_range.value = {
    start_date: moment(obj.start_date).format('YYYY-MM-DD'),
    end_date: moment(obj.end_date).format('YYYY-MM-DD')
  };
  sort.value.sort_key = '';
  sort.value.sort_val = 'asc';
  sort_index.value = 0;
  drop_key.value += 0;
  sort.value.page = 1;
  fetchData();
};

const gotoPage = (page) => {
  sort.value.page = page;
  fetchData();
};

const openCollectionPopup = (openId) => {
  if (collectionPermission.value !== 100) {
    return;
  };

  if (openId === 1 ) {
    if (item.value.disabledCheckbox) {
      openId = 2;
    }
  } else if (openId === 3 && item.value.can_not_edit) {
    return;
  };

  let rows = [];
  rows.push(item.value);
  eventBus.emit('open-collection-handle-dialog', {
    rows: rows,
    id: openId,
    which: item.value.type,
    spec: true //call popup need to refrash modal
  });
};

const viewLive = () => {
  window.open(item.value.share_url, '_blank');
};

const copyLink = () => {
  copyToClipboard(item.value.share_url, { format: 'text/plain' });
  openNotBottom('Link copied', 'success');
};

const openHistory = () => {
  openHistoryVal.value = !openHistoryVal.value;
};

const onDataSourceChange = (item) => {
  shortlink_data.value = item.value;
};


// 按鈕事件
const goPrev = () => {
  eventBus.emit('get-prev-next-item', { currentId: item.value.id, direction: 'prev' });
};

const goNext = () => {
  eventBus.emit('get-prev-next-item', { currentId: item.value.id, direction: 'next' });
};

const getDisabledPrev = () => {
  eventBus.off('no-more-prev-next');
  eventBus.on('no-more-prev-next', ({ direction }) => {
    if (direction === 'prev') {
      isPrevDisabled.value = true;
    } else if (direction === 'next') {
      isNextDisabled.value = true;
    }
  });
};

onMounted(() => {
  openModal();
  refrashModal();
  getDisabledPrev();
});

</script>


<style lang="scss">
@mixin textOver() {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  display: block;
}

.collect-product-page {
  width: 100%;
  height: 100%;
  position: fixed;
  right: 0;
  top: 0;
  font-weight: 400 !important;
  z-index: 1002 !important;

  .ui-modal-side--container {
    width: 100% !important;
    left: 0 !important;
  }

  .ui-side-modal.layer-1>.ui-modal-side--container {
    height: 100vh;
    overflow: hidden;
    overflow-y: hidden;
  }

  .icon-box {
    .svg-icon {
      width: 18px;
      height: 18px;
      cursor: pointer;
    }
  }

  .icon-box2 {
    .svg-icon {
      width: 16px;
      height: 16px;
      cursor: pointer;

      &.svg-icon--scheduled {
        width: 20px;
        height: 20px;
      }
    }

    &.disabled-icon {
      cursor: not-allowed;

      svg{
        cursor: not-allowed;
      }
    }
  }

  .ui-modal-side--container {
    right: 0;
    padding: 0;
  }

  .disabled-box-btn {
    background-color: var(--bg-11);
  }

  .not-allowed-btn{
    cursor: not-allowed;
    pointer-events: none;
  }

  .close-header {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: center;
    padding: 8px 24px;
    border-bottom: solid 1px var(--black-20);

    .el-button {
      & > span {
        gap: 6px;
      }

      svg {
        width: 14px;
        height: 14px;
      }
    }

    .avatar {
      width: 24px;
      height: 24px;

      img {
        width: 24px;
        height: 24px;
        object-fit: cover;
        overflow: hidden;
        border-radius: 50%;
      }
    }


    .creat-name {
      font: var(--font-med-20);
      color: var(--black-90);
      flex: 1;
    }

    .spec-btn {
      svg {
        width: 14px;
        height: 14px;
      }
    }

    .hr {
      width: 2px;
      height: 30px;
      background-color: var(--border);
      margin: 0 -4px;
    }

    .spec-btn-box {
      display: flex;

      .spec-btn1 {
        border-radius: 6px 0 0 6px;

        span {
          transform: rotate(180deg);
        }
      }

      .spec-btn2 {
        margin-left: 0;
        border-radius: 0 6px 6px 0;
      }
    }
  }

  .all-content {
    padding: 0px 24px;
    display: grid;
    grid: auto / 1fr 300px;
    width: 100vw;//85vw;
    min-width: 600px;
    min-height: calc(100vh - 56px);

    &.only-block {
      display: block;
    }

    .detail-content {
      padding: 16px 16px 16px 0;
      min-width: calc(600px - 350px);
      height: calc(100vh - 56px);
      display: grid;
      grid-template-rows: auto auto auto 1fr;
    }
  }

  header {
    display: flex;
    color: var(--black-90);
    overflow: hidden;

    .collection-grid {
      width: 170px;
      height: 170px;
      min-width: 170px;
      position: relative;
    }

    .img-box {
      position: relative;
      width: 170px;
      height: 170px;
      min-width: 170px;
      background-color: var(--bg-03);
      border-radius: 2px;

      &.img-box-white {
        background-color: var(--bg-01);
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .middle {
      margin: 0 16px;
      overflow: hidden;
      flex: 1;

      .name {
        font: var(--font-fg-30);
      }


      .curated-label {
        border-radius: 4px;
        height: 20px;
        background-color: var(--black-20);
        padding: 0 6px;
        display: inline-flex;
        align-items: center;
        font: var(--font-med-12) !important;
        color: var(--black-90);
        justify-content: center;
        max-width: 52px;
      }

      .desc {
        font-size: 16px;
        margin-top: 6px;
        @include textOver();
      }

      .line {
        margin: 20px 0;
        color: var(--dark-blue);
        font: var(--font-med-14);
        display: flex;
        align-items: center;
        gap: 16px;
        flex-wrap: wrap;

        .row {
          display: flex;
          align-items: center;

          &.row-date {
            white-space: nowrap;
            color: var(--black-90);

            .row-name {
              margin-right: 4px;
              font-family: var(--font);
            }
          }

          .row-name {
            font-family: var(--font);
            color: var(--black-60);
          }
        }

        .storefront-state {
          display: inline-flex;
          align-items: center;
          color: var(--black-90);
          text-transform: capitalize;
          margin-left: 4px;

          &::before {
            height: 10px;
            width: 10px;
            content: '';
            display: block;
            border-radius: 5px;
            background-color: var(--yellow);
            margin-right: 5px;
          }

          &.class-green {

            &::before {
              background-color: var(--green);
            }
          }

          &.class-red {

            &::before {
              background-color: var(--alert);
            }
          }

          &.class-normal {

            &::before {
              background-color: var(--gray);
            }
          }
        }

      }
    }

    .hint {
      margin-top: 16px;
      padding: 8px;
      font: var(--font-med-12);
      background: var(--bg-11);
      color: var(--black-75);
      display: flex;
      align-items: center;

      .disabled-alert {
        width: 12px;
        height: 12px;
        margin-right: 10px;
      }

      &.hint-blue {
        background: var(--light-blue);
      }
    }
  }

  .collect-product-page-title {
    font: var(--font-demi-16);
    line-height: 32px;
    color: var(--black-90);
    display: flex;
    align-items: center;
    margin: 16px 0;

    h3 {
      flex: 1;
    }

    .right {
      display: flex;
      align-items: center;
      gap: 12px;

      .ui-checkbox {
        border: solid 1px var(--black-75);
        border-radius: 6px;
        padding: 8px 12px;
        height: 30px;
        margin: 0;
        font: var(--font-fg-12);

        .light {
          margin-right: 0;
        }
      }
    }


  }

  .loading.static {
    margin-top: 48px;
  }

  .ui-table {
    thead {
      position: sticky;
      top: 0;
      z-index: 10;
    }
    th {
      white-space: nowrap;

      .title-content {
        max-width: 380px;
      }
    }

    td {
      .title-content {
        max-width: 380px;
        display: flex;
        align-items: center;

        img {
          width: 59px;
          height: 59px;
          min-width: 59px;
          object-fit: contain;
          margin-right: 14px;
        }

        .right {
          overflow: hidden;

          .name {
            display: flex;
            gap: 6px;

            span {
              font: var(--font-med-16);
              font-weight: 400;
              @include textOver();
              color: var(--black-90);
            }
          }

          .product-link {
            flex-shrink: 0;
            color: var(--black-60);
            position: relative;
            top: 5px;

            &:hover {
              color: var(--Blue-30);
            }

            svg {
              width: 12px;
              height: 12px;
            }
          }


          .small {
            display: flex;
            gap: 6px;

            span {
              font: var(--font-med-14);
              font-weight: 400;
              color: var(--black-75);
              width: auto;
              max-width: 100%;
            }
          }

          .curated-label {
              border-radius: 4px;
              height: 20px;
              background-color: var(--black-20);
              padding: 0 6px;
              display: inline-flex;
              align-items: center;
              font: var(--font-med-12) !important;
              color: var(--black-90);
              justify-content: center;
              max-width: 52px;

              &.remove-label{
                background-color: var(--pink);
                color:var(--white);
              }
          }

          .price-line {
            display: flex;
            gap: 16px;
            align-items: center;

            .alert {
              color: var(--alert);
            }
          }

          .price {
            font: var(--font-demi-14);
            font-weight: normal;
            color: var(--black-75);
            margin-top: 4px;
          }
        }
      }

      .del {
        color: var(--red);
        font-size: 12px;
        font-weight: 400;
      }

      .added-by-label {
        font-size: 12px;
        color: var(--black-60);
        padding: 3px 4px;
        display: inline-block;
        margin-bottom: 4px;
        background-color: var(--bg-03);
        border-radius: 4px;
        white-space: nowrap;
      }

      .small {
        color: var(--black-50);
        @include textOver();

        span {
          @include textOver();
        }
      }
    }
  }
}
</style>